module.exports = __webpack_public_path__ + "assets/img/alert-circle.1015fe52.svg";